import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import { useHistory, useLocation } from "react-router";
import swal from "sweetalert";
import AppHeader from "../../../../Layout/AppHeader";
import AppSidebar from "../../../../Layout/AppSidebar";
import GetAdminService from "../../../../services/admin/GetAdminService";
import "../StudentProgress.css";

const YEAR_OPTIONS = [
{ value: "06", label: "Grade - 6th" },
{ value: "07", label: "Grade - 7th" },
{ value: "08", label: "Grade - 8th" },
{ value: "09", label: "Freshman - 9th" },
{ value: "10", label: "Sophmore - 10th" },
{ value: "11", label: "Junior - 11th" },
{ value: "12", label: "Senior - 12th" }];


const UNIT_OPTIONS = ["Years", "Semesters", "Quarters", "Units", "Others"];

const RequiredGoal = () => {
  const history = useHistory();
  const location = useLocation();
  const [courseId] = useState(
    location?.pathname?.split("/").pop() === "course" ?
    "" :
    location?.pathname?.split("/").pop()
  );
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [, setCourseData] = useState();
  const [courseName, setCourseName] = useState();
  const [courseDescription, setCourseDescription] = useState();
  const [minCreditRequired, setMinCreditRequired] = useState();
  const [minGradeRequired, setMinGradeRequired] = useState();
  const [startYear, setStartYear] = useState();
  const [endYear, setEndYear] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [gradeValue, setGradeValue] = useState("Grade");
  const [yearValue, setYearValue] = useState();
  const [loading, setLoading] = useState(false);

  const canSave =
  courseName &&
  courseDescription &&
  minCreditRequired &&
  startYear &&
  endYear &&
  minGradeRequired &&
  yearValue;

  const getCourseData = () => {
    GetAdminService.getCourse(courseId)
    .then((data) => {
      setCourseData(data?.data);
      setCourseName(data?.data?.name);
      setCourseDescription(data?.data?.description);
      setMinCreditRequired(data?.data?.min_credit_req);
      setMinGradeRequired(data?.data?.min_grade);
      setStartYear(data?.data?.start_year);
      setEndYear(data?.data?.end_year);
      setYearValue(data?.data?.unit);
      if (data?.data?.is_global === true) {
        setIsDisabled(true);
      } else if (data?.data?.is_global === true) {
        setIsDisabled(false);
      }
    })
    .catch(() => {});
  };

  const getGoalField = () => {
    GetAdminService.goalField()
    .then((_data) => {

      // setGoalFieldOption([...data?.data?.objects, ...goalFieldOptionArray]);
    }).catch(() => {});
  };

  const resetFormFields = () => {
    setCourseName();
    setCourseDescription();
    setGradeValue("Grade");
    setMinCreditRequired();
    setEndYear();
    setStartYear();
    setYearValue();
    setMinGradeRequired();
  };

  const saveHandler = () => {
    setLoading(true);
    let obj = {
      description: courseDescription,
      end_year: endYear,
      grade: gradeValue,
      min_credit_req: minCreditRequired,
      min_grade: minGradeRequired,
      name: courseName,
      school_id: user?.school_id,
      start_year: startYear,
      unit: yearValue
    };
    {
      !courseId ?
      GetAdminService.createCourse(obj)
      .then((_data) => {
        resetFormFields();
        setLoading(false);
        history.push("/admin/ccplus");
      })
      .catch((error) => {
        setLoading(false);
        if (
        error?.response?.status === 404 ||
        error?.response?.data?.message === "Course name exist")
        {
          swal({
            text: `${error?.response?.data?.message}`,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true
            },
            closeOnClickOutside: false
          });
        }
      }) :
      GetAdminService.updateCourse(obj, courseId)
      .then((_data) => {
        resetFormFields();
        setLoading(false);
        history.push("/admin/ccplus");
      })
      .catch((error) => {
        setLoading(false);
        if (
        error?.response?.status === 404 ||
        error?.response?.data?.message === "Course name exist")
        {
          swal({
            text: `${error?.response?.data?.message}`,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true
            },
            closeOnClickOutside: false
          });
        }
      });
    }
  };

  useEffect(() => {
    getCourseData();
    getGoalField();
  }, []);

  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="admin-ccplus-page">
            <div className="admin-ccplus-header">
              <div>
                <h1 className="admin-ccplus-title">
                  Create Required Course Set
                </h1>
                <p className="admin-ccplus-subtitle">
                  Define course requirement details for student goals
                </p>
              </div>
              <div className="admin-ccplus-header-actions">
                <button
                  type="button"
                  onClick={() => history.push("/admin/ccplus")}
                  className="admin-ccplus-btn ghost toolbar">
                  
                  Back
                </button>
              </div>
            </div>

            <div className="admin-ccplus-form-card admin-course-set-form">
              <div className="admin-course-set-field">
                <label className="admin-course-set-label" htmlFor="course-name">
                  Requirement Name <span className="admin-course-set-required">*</span>
                </label>
                <input
                  id="course-name"
                  value={courseName || ""}
                  onChange={(e) => setCourseName(e.target.value)}
                  type="text"
                  className="admin-course-set-input"
                  placeholder="Enter requirement name" />
                
              </div>

              <div className="admin-course-set-field">
                <label
                  className="admin-course-set-label"
                  htmlFor="course-description">
                  
                  Requirement Description{" "}
                  <span className="admin-course-set-required">*</span>
                </label>
                <textarea
                  id="course-description"
                  value={courseDescription || ""}
                  onChange={(e) => setCourseDescription(e.target.value)}
                  className="admin-course-set-input admin-course-set-textarea"
                  rows="5"
                  placeholder="Enter requirement description" />
                
              </div>

              <div className="admin-course-set-rule">
                <p className="admin-course-set-rule-title">
                  Credit / Time Requirement
                </p>
                <p className="admin-course-set-rule-text">
                  Student must take a minimum of{" "}
                  <input
                    type="text"
                    value={minCreditRequired || ""}
                    className="admin-course-set-inline-input"
                    disabled={isDisabled}
                    onChange={(e) => setMinCreditRequired(e.target.value)} />
                  
                  <select
                    value={yearValue || ""}
                    disabled={isDisabled}
                    onChange={(e) => setYearValue(e.target.value)}
                    className="admin-course-set-inline-select">
                    
                    <option disabled value="">
                      Select
                    </option>
                    {UNIT_OPTIONS.map((unit) =>
                    <option key={unit} value={unit}>
                        {unit}
                      </option>
                    )}
                  </select>{" "}
                  worth of courses.
                </p>
              </div>

              <div className="admin-course-set-rule">
                <p className="admin-course-set-rule-title">Minimum Grade</p>
                <p className="admin-course-set-rule-text">
                  Student must have a minimum of{" "}
                  <input
                    type="text"
                    value={gradeValue}
                    placeholder="Grade"
                    className="admin-course-set-inline-input"
                    onChange={(e) => setGradeValue(e.target.value)}
                    disabled />
                  
                  <input
                    type="text"
                    value={minGradeRequired || ""}
                    className="admin-course-set-inline-input"
                    disabled={isDisabled}
                    onChange={(e) => setMinGradeRequired(e.target.value)} />
                  {" "}
                  for a course to qualify.
                </p>
              </div>

              <div className="admin-course-set-rule">
                <p className="admin-course-set-rule-title">
                  Year Range{" "}
                  <span className="admin-course-set-optional">(optional)</span>
                </p>
                <div className="admin-course-set-year-row">
                  <div className="admin-course-set-year-field">
                    <label className="admin-course-set-label" htmlFor="start-year">
                      Start Year
                    </label>
                    <select
                      id="start-year"
                      disabled={isDisabled}
                      value={startYear || ""}
                      onChange={(e) => setStartYear(e.target.value)}
                      className="admin-course-set-input">
                      
                      <option disabled value="">
                        Select the start year
                      </option>
                      {YEAR_OPTIONS.map((opt) =>
                      <option key={`start-${opt.value}`} value={opt.value}>
                          {opt.label}
                        </option>
                      )}
                    </select>
                  </div>
                  <div className="admin-course-set-year-field">
                    <label className="admin-course-set-label" htmlFor="end-year">
                      End Year
                    </label>
                    <select
                      id="end-year"
                      disabled={isDisabled}
                      value={endYear || ""}
                      onChange={(e) => setEndYear(e.target.value)}
                      className="admin-course-set-input">
                      
                      <option disabled value="">
                        Select the end year
                      </option>
                      {YEAR_OPTIONS.map((opt) =>
                      <option key={`end-${opt.value}`} value={opt.value}>
                          {opt.label}
                        </option>
                      )}
                    </select>
                  </div>
                </div>
              </div>

              <div className="admin-ccplus-form-actions">
                <button
                  type="button"
                  disabled={!canSave || loading}
                  onClick={saveHandler}
                  className={`admin-ccplus-btn primary ${
                  !canSave || loading ? "is-disabled" : ""
                  }`}>
                  
                  <FontAwesomeIcon icon={faSave} />
                  Save
                  {loading &&
                  <Loader
                    type="TailSpin"
                    color="white"
                    height={18}
                    width={18} />}

                  
                </button>

                <button
                  type="button"
                  onClick={() => history.push("/admin/ccplus")}
                  className="admin-ccplus-btn ghost">
                  
                  <FontAwesomeIcon icon={faTimes} />
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>);

};

export default RequiredGoal;